import { YesNoNotNecessaryAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

// The template editor preview shows every field so the whole template can be reviewed, even the verification method
// that stays hidden until the identity is known to be verified.
export function showsIdentityVerificationMethod(answer: YesNoNotNecessaryAnswer | null | undefined, isPreview: boolean) {
    return isPreview || answer === YesNoNotNecessaryAnswer.Yes;
}
